module.exports = __webpack_public_path__ + "static/media/notSuccess.514ebbf7.svg";